module.exports = __webpack_public_path__ + "media/applicants/cnn-0dbfa172.jpg";